export const env = {
  appEnv: import.meta.env.VITE_APP_ENV,
  baseUrl: import.meta.env.VITE_BASE_URL,
  notificationTabStatus: import.meta.env.VITE_DOITPAY_STATUS_NOTIFICATION,
  googleClientID: import.meta.env.VITE_GOOGLE_CLIENT_ID,
  adminDoitpayUrl: import.meta.env.VITE_ADMIN_DOITPAY_URL,
};
